import Drawer from '@components/group/info/drawer';
import LoadingIndicator from '@components/group/loading-indicator';
import Map from '@components/group//info/map';
import Tray from '@components/map/tray';
import FilePreview from '@shared/files/file-preview';
import FragmentLayout from '@shared/fragment-layout';

const Group = FragmentLayout(LoadingIndicator, Drawer, Map, Tray, FilePreview);

export default Group;
